<h1 class="text-2xl" mat-dialog-title>{{title}} </h1>
<mat-dialog-content>
    <p>{{message}}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button *ngIf="!Data.clearButtonClose" mat-button mat-dialog-close>Cancel</button>
    <button color="warn" mat-button [mat-dialog-close]="true" cdkFocusInitial>{{okAction}}</button>
</mat-dialog-actions>